import { render, staticRenderFns } from "./tab_files.vue?vue&type=template&id=264b263a&scoped=true&"
import script from "./tab_files.vue?vue&type=script&lang=js&"
export * from "./tab_files.vue?vue&type=script&lang=js&"
import style0 from "./tab_files.vue?vue&type=style&index=0&id=264b263a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264b263a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('264b263a')) {
      api.createRecord('264b263a', component.options)
    } else {
      api.reload('264b263a', component.options)
    }
    module.hot.accept("./tab_files.vue?vue&type=template&id=264b263a&scoped=true&", function () {
      api.rerender('264b263a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/inside/action/tabs/files/tab_files.vue"
export default component.exports